export class ManagerMonitoringApi {

    #client;

    /**
     * @param {ServerData} client
     * */
    constructor(client) {
        this.#client = client;
    }


    /**
     * @param {string} buildingId
     * @return {Promise<Any>}
     * */
    async getState(buildingId) {
        return this.#client.get(`/managers/monitoring/${buildingId}/state`);
    }

    async removeFromCampaign(buildingId, apartmentNumbers){
        return this.#client.put(`/managers/monitoring/${buildingId}/stopped`, {apartmentNumbers});

    }
    async addToCampaign(buildingId, apartmentNumbers){
        return this.#client.put(`/managers/monitoring/${buildingId}/started`, {apartmentNumbers});

    }

}
